import type { ComponentType } from "react";
import {
    AddressIcon,
    BankIcon,
    CalendarIcon,
    CancelledDocumentIcon,
    CarDocumentIcon,
    CarIcon,
    DocumentIcon,
    HouseIcon,
    Money2Icon,
    MoneyIcon,
    MoneyTransferIcon,
    ProfileIcon,
} from "vig-ui-library";
import type { IconProps } from "vig-ui-library";

/**
 * Hardcoded Material Design icon name → PKP SVG icon (until BE exposes reactIcon / PKP keys on listing).
 * Fallback: DocumentIcon.
 */
const MATERIAL_ICON_TO_PK: Record<string, ComponentType<IconProps>> = {
    person_search: ProfileIcon,
    account_balance_wallet: MoneyTransferIcon,
    timelapse: CalendarIcon,
    euro_symbol: MoneyIcon,
    directions_car: CarIcon,
    location_on: HouseIcon,
    linear_scale: CancelledDocumentIcon,
    personal_injury: DocumentIcon,
    dynamic_feed: CancelledDocumentIcon,
    account_balance: BankIcon,
    flash_off: CarDocumentIcon,
    forward_to_inbox: AddressIcon,
    request_quote: Money2Icon,
};

export type RequestTablePkIconSwitcherProps = IconProps & {
    /** Value from RequestDto.icon (RequestTypeIcon / Material icon name). */
    materialIconName?: string | null;
};

export function RequestTablePkIconSwitcher({
    materialIconName,
    width = 26,
    height = 26,
    color = "#fff",
}: RequestTablePkIconSwitcherProps) {
    const key = typeof materialIconName === "string" ? materialIconName.trim().toLowerCase() : "";
    const Icon = key && MATERIAL_ICON_TO_PK[key] ? MATERIAL_ICON_TO_PK[key] : DocumentIcon;

    return <Icon width={width} height={height} color={color} />;
}
